(function () {
  'use strict';

  if (window.DeckauraTierPicker) return;

  var groups = [];
  var scheduled = false;
  var copy = null;

  function setAttribute(node, name, value) {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function setText(node, value) {
    if (node.textContent !== value) node.textContent = value;
  }

  function available(option) {
    return !option.disabled && !option.hidden && option.getAttribute('aria-disabled') !== 'true';
  }

  function optionsFor(group) {
    return Array.prototype.slice.call(group.querySelectorAll('button[data-tier][role="radio"]'));
  }

  function selectionName(option) {
    var name = option.querySelector('.ddr-pack__t, .ddr-gate__choice small');
    var price = option.querySelector('.ddr-pack__p, .ddr-gate__choice strong');
    return [name && name.textContent.trim(), price && price.textContent.trim()].filter(Boolean).join(' · ');
  }

  function syncGroup(group) {
    var options = optionsFor(group);
    var enabled = options.filter(available);
    var selected = enabled.find(function (option) { return option.getAttribute('aria-checked') === 'true'; });
    var tabStop = selected || enabled[0];
    var hint = document.getElementById(group.id === 'ddrGatePrices' ? 'ddrGateSelectionHint' : 'ddrPackSelectionHint');

    setAttribute(group, 'data-deckaura-tier-picker', 'true');
    options.forEach(function (option) {
      setAttribute(option, 'tabindex', option === tabStop ? '0' : '-1');
      var label = option.querySelector('.ddr-tier-picker__choice');
      if (!label) {
        label = document.createElement('span');
        label.className = 'ddr-tier-picker__choice';
        label.setAttribute('aria-hidden', 'true');
        option.appendChild(label);
      }
      setText(label, option === selected ? '✓ ' + copy.selected : '○ ' + copy.select);
    });

    if (hint) {
      hint.hidden = !enabled.length;
      setText(hint, selected ? copy.summary.replace('{name}', selectionName(selected)) : copy.prompt);
    }
    if (selected && group.classList.contains('is-choice-needed')) group.classList.remove('is-choice-needed');
  }

  function sync() {
    scheduled = false;
    groups.forEach(syncGroup);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(sync);
    else window.setTimeout(sync, 0);
  }

  function focusChoice(container) {
    var group = container && container.querySelector('#ddrGatePrices[data-deckaura-tier-picker]');
    if (!group || !copy) return false;
    syncGroup(group);
    var choices = optionsFor(group).filter(available);
    if (!choices.length) return false;
    group.classList.add('is-choice-needed');
    var target = choices.find(function (option) { return option.getAttribute('aria-checked') === 'true'; }) || choices[0];
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    group.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
    return true;
  }

  function init() {
    var gate = document.getElementById('ddrGate');
    var payload = document.getElementById('DeckauraTierPickerCopy');
    if (!gate || !gate.classList.contains('ddr-gate--enterprise-shared') || gate.classList.contains('ddr-gate--direct-tiers') || !payload) return;
    try { copy = JSON.parse(payload.textContent); } catch (_) { return; }
    if (!copy || !copy.prompt || !copy.select || !copy.selected || !copy.summary) return;
    groups = [document.getElementById('ddrGatePrices'), document.getElementById('ddrPack')].filter(Boolean);
    groups.forEach(function (group) {
      if (window.MutationObserver) new MutationObserver(schedule).observe(group, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled', 'hidden', 'aria-disabled', 'aria-checked']
      });
    });
    document.addEventListener('deckaura:paid-offer-ready', schedule);
    document.addEventListener('deckaura:paid-offer-updated', schedule);
    sync();
  }

  window.DeckauraTierPicker = { focusChoice: focusChoice };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
